import { create } from 'zustand';
import type { CountryData } from '../countries';

interface CountryState {
    countryData: CountryData[] | null;
    setCountryData: (data: CountryData[]) => void;
}

export const useCountryStore = create<CountryState>((set) => ({
    countryData: null,
    setCountryData: (data) => set({ countryData: data }),
}));
